import type { CategoriaCurva } from "@/modules/financeiro-configuracoes";

export const CURVAS_TITULO = "Curvas de mensalização";
export const CURVAS_DESCRICAO =
  "Defina como o valor de Serviços, de Materiais e de Facilidades se distribui ao longo dos meses. Cada curva tem três fases (antes, durante e depois da Obra), e os percentuais somam 100%. No Durante, o percentual se divide pelos meses da Obra; no Antes e no Após, pelos meses da curva. As curvas ativas ficam disponíveis ao projetar o escopo na aba Planejamento e Controle da Obra e nas Facilidades da Obra.";

export const CURVAS_NOVA_LABEL = "Nova curva";
export const CURVAS_MOSTRAR_INATIVAS_LABEL = "Mostrar inativas";
export const CURVAS_FILTRO_CATEGORIA_ROTULO = "Categoria";
export const CURVAS_LISTA_LABEL = "Curvas de mensalização";

export const CURVAS_FORBIDDEN_MESSAGE =
  "Você não tem permissão para consultar as curvas de mensalização.";
export const CURVAS_ERROR_MESSAGE = "Não foi possível carregar as curvas de mensalização.";
export const CURVAS_LOADING_LABEL = "Carregando curvas...";
export const CURVAS_VAZIO_TITULO = "Nenhuma curva cadastrada";
export const CURVAS_VAZIO_DESCRICAO =
  "As curvas cadastradas aqui distribuem o valor do escopo ao longo dos meses.";

export const CURVAS_COLUNAS = {
  nome: "Nome",
  categoria: "Categoria",
  antes: "Antes",
  durante: "Durante",
  apos: "Após",
  meses: "Meses",
  alteradaEm: "Alterada em",
} as const;

export const CURVAS_TAG_INATIVA = "Inativa";
export const CURVAS_PRAZO_DA_OBRA = "Prazo da Obra";
export const CURVAS_DURANTE_APOIO = "prazo da Obra";
export const CURVAS_EDITAR_LABEL = "Editar";
export const CURVAS_EXPANDIR = "Mostrar prévia mensal de";
export const CURVAS_RECOLHER = "Ocultar prévia mensal de";

export const PREVIA_TITULO = "Prévia mensal";
export const PREVIA_LABEL_FASE = "Fase";
export const PREVIA_LABEL_MES = "Mês relativo";
export const PREVIA_LABEL_PERCENTUAL = "Percentual";
export const PREVIA_DURANTE_MES = "Início ao fim da Obra";
export const PREVIA_NOTA =
  "“Início” é o mês em que a Obra começa e “Fim”, o mês em que ela termina. Vale para Serviços, Materiais e Facilidades.";

export const CATEGORIA_TODAS = "TODAS";
export type CategoriaFiltro = CategoriaCurva | typeof CATEGORIA_TODAS;

export const CATEGORIA_ROTULOS: Record<CategoriaCurva, string> = {
  SERVICOS: "Serviços",
  MATERIAIS: "Materiais",
  FACILIDADES: "Facilidades",
};

export const CATEGORIA_OPCOES: readonly { label: string; value: CategoriaFiltro }[] = [
  { label: "Todas", value: CATEGORIA_TODAS },
  { label: CATEGORIA_ROTULOS.SERVICOS, value: "SERVICOS" },
  { label: CATEGORIA_ROTULOS.MATERIAIS, value: "MATERIAIS" },
  { label: CATEGORIA_ROTULOS.FACILIDADES, value: "FACILIDADES" },
];

/** Categorias de uma curva no cadastro: sem "Todas", que só existe no filtro. */
export const CATEGORIA_OPCOES_CADASTRO: readonly { label: string; value: CategoriaCurva }[] = [
  { label: CATEGORIA_ROTULOS.SERVICOS, value: "SERVICOS" },
  { label: CATEGORIA_ROTULOS.MATERIAIS, value: "MATERIAIS" },
  { label: CATEGORIA_ROTULOS.FACILIDADES, value: "FACILIDADES" },
];

export const CURVAS_INATIVAR_LABEL = "Inativar";
export const CURVAS_ATIVAR_LABEL = "Ativar";
export const CURVAS_ULTIMA_ATIVA =
  "É necessário ter pelo menos uma curva ativa para Materiais, Serviços e Facilidades.";
export const CURVAS_SITUACAO_ERRO = "Não foi possível alterar a situação da curva.";

export const INATIVAR_TITULO = "Inativar curva";
export const INATIVAR_SUBTITULO = "Essa ação tira a curva da escolha dos novos escopos macro.";
export const INATIVAR_CONFIRMAR = "Inativar curva";
export const INATIVAR_EFEITOS_TITULO = "O que acontece ao inativar";
export const INATIVAR_INTRO = "Você vai inativar esta curva de mensalização:";
export const INATIVAR_EFEITOS = [
  "Ela deixa de aparecer na escolha de curva dos novos escopos macro.",
  "Os escopos que já a usam continuam com ela, sem recalcular a mensalização.",
  "Nada é excluído: para usar de novo, marque “Mostrar inativas” e ative.",
];

export const CURVA_CRIADA = "Curva criada com sucesso.";
export const CURVA_EDITADA = "Curva editada com sucesso.";
export const CURVA_INATIVADA = "Curva inativada com sucesso.";
export const CURVA_ATIVADA = "Curva ativada com sucesso.";
